<!-- START Wrapper -->
<div class="page-wrapper" id="main-wrapper" (click)="onMainWrapperClick($event)" [attr.data-layout]="showUserLogin() ? 'vertical' : 'none'"
  data-navbarbg="skin6" [attr.data-sidebartype]="showUserLogin() ? 'full' : 'none'"
  data-sidebar-position="fixed" data-header-position="fixed">
  
  <app-sidebar *ngIf="showUserLogin()"></app-sidebar>

  <div class="body-wrapper" [ngClass]="{'no-sidebar': !showUserLogin()}">
    <app-header *ngIf="showUserLogin()"></app-header>
    <div class="body-wrapper-inner">
      <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="showUserLogin()"></app-footer>
  </div>
</div>
